import { Button, Divider, Skeleton, Space, Tag } from 'antd';
import gql from 'graphql-tag';
import { useAuthedMutation } from 'utils/qlAuth';
import React from 'react';
import { StoryFramesModel } from 'interface/models';
import { LeonardoUser } from './LeonardoUser';
import { StoryBoard_OneFrameRow } from './StoryBoard_OneFrameRow';
import { useStoryFramesQuery } from 'queries/ai-threshold';
import { StoryController_translateStory } from '../buttons';

export const StoryBoard = (props: { qStory: any; storyId: number }) => {
  const qFrames = useStoryFramesQuery(props.storyId);

  const [updateFrame] = useAuthedMutation(
    gql`
      mutation StoryController_updateFrame($frameId: Int!, $input: JSON!) {
        StoryController_updateFrame(frameId: $frameId, config: $input) {
          id
        }
      }
    `,
  );

  const [frames, setFrames] = React.useState<StoryFramesModel[]>([]);
  const [displayType, setDisplayType] = React.useState<string>('text');

  React.useEffect(() => {
    if (qFrames.data?.FrameController_getStoryFrames) {
      setFrames(qFrames.data.FrameController_getStoryFrames);
    }
  }, [qFrames.data]);

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }

  const setNewTimeStart = async (frameId: number, newTimeStart: number) => {
    await updateFrame({
      variables: {
        frameId,
        input: { timeStart: newTimeStart },
      },
    });
    setFrames(prevFrames => prevFrames.map(frame => (frame.id === frameId ? { ...frame, timeStart: newTimeStart } : frame)));
  };

  const onFrameChange = async (newFrame: StoryFramesModel) => {
    setFrames(prevFrames => prevFrames.map(frame => (frame.id === newFrame.id ? { ...newFrame } : frame)));
  };

  const sortedFrames = frames.sort((a, b) => {
    const t = (a.timeStart || 0) - (b.timeStart || 0);
    if (t !== 0) {
      return t;
    }
    return a.id - b.id;
  });

  for (let i = 0; i < sortedFrames.length; i++) {
    if (!sortedFrames[i].timeStart && i > 0) {
      sortedFrames[i].timeStart = sortedFrames[i - 1].timeStart + (sortedFrames[i - 1].timeLength || 3000);
    }
  }

  return (
    <>
      <Space direction="horizontal">
        <Button size="small" onClick={() => setDisplayType('text')} type={displayType === 'text' ? 'primary' : 'default'}>
          Text
        </Button>
        <Button size="small" onClick={() => setDisplayType('image-medium')} type={displayType === 'image-medium' ? 'primary' : 'default'}>
          Image medium
        </Button>
        <Button size="small" onClick={() => setDisplayType('image-big')} type={displayType === 'image-big' ? 'primary' : 'default'}>
          Image big
        </Button>
        <Tag color="blue">Frames: {sortedFrames.length}</Tag>
        <LeonardoUser />
        <StoryController_translateStory storyId={props.storyId} qFrames={qFrames} />
      </Space>
      <Divider />
      {(sortedFrames || []).map((item, index) => {
        const next = sortedFrames[index + 1];
        const prev = sortedFrames[index - 1];
        return (
          <StoryBoard_OneFrameRow
            key={item.id}
            current={item}
            prev={prev}
            next={next}
            displayType={displayType}
            setNewTimeStart={setNewTimeStart}
            onChange={onFrameChange}
            qFrames={qFrames}
            storyId={props.storyId}
          />
        );
      })}
    </>
  );
};
